import { Menu } from 'antd';
import '../../assets/style.css'
import { Link } from 'react-router-dom'
import logo from './assets/logo2.png'
import { UserOutlined, ToolOutlined, RetweetOutlined,
            AppstoreOutlined, PlusSquareOutlined,
            ArrowLeftOutlined, FullscreenOutlined, DollarCircleOutlined,
            TransactionOutlined, ArrowRightOutlined, InteractionOutlined,
            SettingFilled, MenuFoldOutlined, MenuUnfoldOutlined, FullscreenExitOutlined,
            UserSwitchOutlined, UsergroupAddOutlined, ExportOutlined,
            SwapOutlined, VerticalAlignMiddleOutlined, DragOutlined, RotateLeftOutlined
        }
from '@ant-design/icons';
import React, { useState } from 'react';
import { PRIMARY_COLOR } from '../../utils/constants'

const menuLabel = (text: string) => (
    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', maxWidth: 130 }}>
        {text}
    </span>
);

interface Props {
    onMenuSelect?: () => void;
}

export default function Index({ onMenuSelect }: Props) {
    const [openKeys, setOpenKeys] = useState<string[]>(['sub1']);

    const onOpenChange = (keys: string[]) => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    };

    const items = [
        {
            key: 'sub1',
            icon: <UsergroupAddOutlined />,
            label: menuLabel('Opérations Client'),
            style: { backgroundColor: PRIMARY_COLOR },
            children: [
                { key: '1',   icon: <UserSwitchOutlined />,  label: <Link to="/clients">Clients</Link> },
                { key: '2',   icon: <InteractionOutlined />, label: <Link to="/retrait">Rétrait</Link> },
                { key: '333', icon: <InteractionOutlined />, label: <Link to="/retrait/valide">Valider Retrait</Link> },
                { key: '3',   icon: <ExportOutlined />,      label: <Link to="/depot">Dépot</Link> },
                { key: '33',  icon: <ExportOutlined />,      label: <Link to="/depot/valide">Valider Depot</Link> },
            ],
        },
        {
            key: 'sub2',
            icon: <FullscreenExitOutlined />,
            label: menuLabel('Factures Entrée'),
            children: [
                { key: '4',  icon: <ArrowRightOutlined />, label: <Link to="/factures/entrees">Entrées</Link> },
                { key: '5',  icon: <MenuFoldOutlined />,   label: <Link to="/sorties/valide">Valider Sorties</Link> },
            ],
        },
        {
            key: 'sub22',
            icon: <FullscreenOutlined />,
            label: menuLabel('Factures Sortie'),
            children: [
                { key: '44', icon: <ArrowLeftOutlined />,   label: <Link to="/factures/sorties">Sorties</Link> },
                { key: '55', icon: <MenuUnfoldOutlined />,  label: <Link to="/entrees/valide">Valider Entrées</Link> },
            ],
        },
        {
            key: 'sub4',
            icon: <RetweetOutlined />,
            label: menuLabel('Rapports'),
            children: [
                { key: '11',   icon: <RotateLeftOutlined />,          label: <Link to="/rapports/credits">Crédits</Link> },
                { key: '113',  icon: <SwapOutlined />,                label: <Link to="/rapports/clients/in-bureau">Entrée/sortie</Link> },
                { key: '112',  icon: <DragOutlined />,                label: <Link to="/rapports/clients/hors-bureau">Hors bureau</Link> },
                { key: '1123', icon: <VerticalAlignMiddleOutlined />, label: <Link to="/rapports/all-transations/by-client">Transaction / client</Link> },
                { key: '111',  icon: <DollarCircleOutlined />,        label: <Link to="/rapports/soldes-bureau">Soldes Bureau</Link> },
            ],
        },
        {
            key: 'sub3',
            icon: <SettingFilled />,
            label: menuLabel('Parametres'),
            children: [
                { key: '6',   icon: <UserOutlined />,        label: <Link to="/utilisateurs">Utilisateurs</Link> },
                { key: '7',   icon: <TransactionOutlined />, label: <Link to="/devises">Devises</Link> },
                { key: '8',   icon: <ToolOutlined />,        label: <Link to="/taux-jours">Taux du jour</Link> },
                { key: '9',   icon: <AppstoreOutlined />,    label: <Link to="/depenses">Depenses</Link> },
                { key: '99',  icon: <PlusSquareOutlined />,  label: <Link to="/inject-fond">Injecter fond</Link> },
                { key: '990', icon: <PlusSquareOutlined />,  label: <Link to="/depenses/validate/depense-inject">Valider</Link> },
                { key: '10',  icon: <DollarCircleOutlined />,label: <Link to="/comptes-globales">Soldes</Link> },
            ],
        },
    ];

    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.1)',
                margin: '12px',
                borderRadius: 6,
            }}>
                <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <img src={logo} alt="logo" style={{ height: 32, width: 50, objectFit: 'contain', flexShrink: 0 }} />
                    <span style={{ color: '#fff', fontSize: 16, fontWeight: 600, whiteSpace: 'nowrap' }}>B-Devise</span>
                </Link>
            </div>
            <Menu
                style={{ backgroundColor: PRIMARY_COLOR }}
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['4']}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                onSelect={onMenuSelect}
                items={items}
            />
        </>
    );
}
